import React from 'react';
import Slider from 'react-slick';
import getDistance from '../utils/getDistance';
import OpeningTimes from './OpeningTimes';

import { CloseIcon } from '../icons';

const DevelopmentCard = (props) => {
  const settings = {
    dots: false,
    draggable: false,
    lazyLoad: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !props.item.coming_soon,
  };

  const handleCloseIconClick = () => {
    const card = event.target.closest('.development-card');
    if (card && card.classList.contains('development-card--selected')) {
      card.classList.remove('development-card--selected');
    }
  };

  return (
    <div
      className={`development-card ${
        props.item.is_bespoke ? 'development-card--bespoke' : ''
      } ${props.isLocationSearch && 'development-card--miles-enabled'}`}
      key={props.item.id}
      data-id={props.item.id}
    >
      <div className="development-card__close" onClick={handleCloseIconClick}>
        <CloseIcon />
      </div>
      <div className="development-card__gallery">
        {props.item.coming_soon && (
          <div className="development-card__gallery-status-overlay">
            <h2 className="development-card__gallery-status-text">
              Coming Soon
            </h2>
          </div>
        )}

        <Slider {...settings}>
          {props.item.images.map((image, index) => (
            <a
              href={props.item.link}
              className="development-card__gallery-item"
              key={index}
            >
              <div className="development-card__gallery-image">
                <img
                  src={image.url}
                  alt={props.item.title}
                  className="development-card__image"
                  loading="lazy"
                />
              </div>
            </a>
          ))}
        </Slider>
      </div>
      <a href={props.item.link} className="development-card__details">
        <div className="development-card__details-container">
          <div className="wrap development-card__wrap">
            {props?.item?.images[0] && (
              <figure className="development-card__figure">
                <img
                  className="development-card__image"
                  src={props.item.images[0].url}
                  alt={props.item.title}
                />
              </figure>
            )}
            <div className="wrap development-card__wrap--content">
              {props.isLocationSearch ? (
                <span className="development-card__details-distance text-link-uppercase text-link-uppercase--gold">
                  {getDistance(
                    props.coords.lat,
                    props.coords.lng,
                    props.item.location.lat,
                    props.item.location.lng
                  )}
                  Miles Away
                </span>
              ) : null}
              <h2 className="development-card__details-title">
                {props.item.title}
              </h2>
              <h3 className="development-card__details-address">
                {props.item.street}, {props.item.city}, {props.item.postcode}
              </h3>
              {props.item.is_bespoke ? (
                <div className="development-card__bespoke-wrap">
                  <div className="development-card__details-status">
                    Bespoke Collection
                  </div>
                  <OpeningTimes
                    id={props.item.id}
                    customerSuite={props.item.customerSuite ?? 'Customer Suite'}
                  />
                </div>
              ) : (
                <OpeningTimes
                  id={props.item.id}
                  customerSuite={props.item.customerSuite ?? 'Customer Suite'}
                />
              )}
            </div>
          </div>
          <div className="development-card__details-footer">
            <div className="development-card__details-footerItem">
              {props.item.bedrooms.length === 1 ? (
                <span>{props.item.bedrooms[0]}</span>
              ) : (
                <span>
                  {props.item.bedrooms[0]} -{' '}
                  {props.item.bedrooms[props.item.bedrooms.length - 1]}
                </span>
              )}{' '}
              bed homes
            </div>

            {!props.item.all_sold_hide_pricing ? (
              <div className="development-card__details-footerItem">
                {props.item.from_price_text ? 'From ' : null}
                {props.item.hide_pricing
                  ? '£ POA'
                  : props.item.lowest_price === props.item.highest_price
                  ? null
                  : props.item.lowest_price !== 0
                  ? new Intl.NumberFormat('en-GB', {
                      currency: 'GBP',
                      style: 'currency',
                      minimumFractionDigits: 0,
                    }).format(props.item.lowest_price)
                  : null}
                {!props.item.hide_pricing &&
                props.item.lowest_price !== 0 &&
                props.item.highest_price !== 0 &&
                props.item.lowest_price !== props.item.highest_price
                  ? '-'
                  : null}
                {props.item.hide_pricing || props.item.highest_price === 0
                  ? ''
                  : new Intl.NumberFormat('en-GB', {
                      currency: 'GBP',
                      style: 'currency',
                      minimumFractionDigits: 0,
                    }).format(props.item.highest_price)}
              </div>
            ) : (
              <div className="development-card__details-footerItem development-card__details-footerItem--gold">
                All Sold
              </div>
            )}
          </div>
        </div>
      </a>
    </div>
  );
};

export default DevelopmentCard;
